import { IRepository, IRepositorySummary } from '@/types';
import { apiClient, fetchWrapper, getRequestHeaders, IBaseResponse } from './apiBase';
import { IRepositoryResponse } from './repositoryApi';
import { BASE_API_URL } from '@/config/environment';

export type TForkStatus = {
  status: 'pending' | 'complete' | 'failed';
  progress: number | null;
  repository: string;
};

export interface IForkStatusResponse extends IBaseResponse {
  fork_status: TForkStatus;
  repository: IRepositorySummary;
}

export const fetchForkStatus = async (
  namespace: string,
  repositoryName: string,
  token?: string,
): Promise<IForkStatusResponse> => {
  const targetUrl = `${BASE_API_URL}/repos/${namespace}/${repositoryName}/fork/status`;

  return await fetchWrapper({
    resourceName: 'stars',
    targetUrl,
    authToken: token,
    resourceContext: { namespace, repositoryName },
  });
};

export const createRepositoryFork = async ({
  repository,
  newRepositoryName,
  organizationId,
  token,
}: {
  repository: IRepository;
  newRepositoryName?: string;
  organizationId?: string;
  token?: string;
}): Promise<IRepositoryResponse> => {
  const postBody = {
    new_repo_name: newRepositoryName || repository.name,
    organization_id: organizationId ? organizationId : null,
  };
  const resourceUrl = `/repos/${repository.namespace}/${repository.name}/fork`;
  const requestHeaders = getRequestHeaders(token);
  try {
    const res = await apiClient.post(resourceUrl, postBody, { headers: requestHeaders });
    return res.data;
  } catch (error: any) {
    return error.response.data;
  }
};
